import { BookingCompleteData } from "@capone/common";

export const buildPackageBookingData = (): BookingCompleteData => ({
  earnedRewards: { value: 0, currency: "Miles" },
  booking: { type: "package" },
});
